<template>
    <div class="cabinet-nav cabinet-nav--public flex flex-justify-sb">
        <div class="cabinet-nav__header flex flex-align-center">
            <i class="cabinet-nav__icon cabinet-nav__icon--group-ellipse"></i>
            <router-link
                to="/"
                class="cabinet-nav__logo--goldnet-market"
            ></router-link>
        </div>

        <div class="cabinet-nav-links">
            <ul class="cabinet-nav-list">
                <li class="cabinet-nav-list__item cabinet-nav-list__item--home">
                    <router-link
                        to="/account"
                        exact
                        class="cabinet-nav-list__link flex flex-align-center	js-menu-link"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--home-2"
                        ></i>
                        <div class="cabinet-nav-list__link-title">Главная</div>
                    </router-link>
                </li>

                <li class="cabinet-nav-list__item">
                    <a
                        v-if="isMobile"
                        href="javascript:void(0)"
                        class="cabinet-nav-list__link	cabinet-nav-list__link--catalog	flex flex-align-center js-menu-link js-catalog-button-mobile"
                        @click="showMenu"
                    >
                        <i
                            class="cabinet-nav__icon	cabinet-nav__icon--three-strips"
                        ></i>
                        <div class="cabinet-nav-list__link-title">Каталог</div>
                    </a>
                    <router-link
                        v-else
                        to="/account/catalog"
                        exact
                        class="cabinet-nav-list__link	cabinet-nav-list__link--catalog	flex flex-align-center js-menu-link js-catalog-button-mobile"
                    >
                        <i
                            class="cabinet-nav__icon	cabinet-nav__icon--three-strips"
                        ></i>
                        <div class="cabinet-nav-list__link-title">Каталог</div>
                    </router-link>

                    <div class="cabinet-nav__category-menu category-menu">
                        <div v-if="categories" class="category-menu__left">
                            <ul
                                v-for="categorie in categories.slice(
                                    0,
                                    categories.length > 1 ? Math.ceil(categories.length / 2) : 1
                                )"
                                :key="categorie.id"
                                class="category-menu__list"
                            >
                                <li class="category-menu__list-item--title">
                                    <router-link
                                        :to="{
                                            name: 'CategoryID',
                                            params: { id: categorie.url }
                                        }"
                                    >
                                        {{ categorie.name }}
                                    </router-link>
                                </li>

                                <template v-if="categorie.children">
                                    <li
                                        v-for="subCategorie in categorie.children.slice(0, 5)"
                                        :key="subCategorie.id"
                                        class="category-menu__list-item"
                                    >
                                        <router-link
                                            :to="{
                                                name: 'CategoryID',
                                                params: {
                                                    id: subCategorie.url,
                                                }
                                            }"
                                        >
                                            {{ subCategorie.name }}
                                        </router-link>
                                    </li>
                                </template>
                            </ul>
                        </div>

                        <div v-if="categories" class="category-menu__right">
                            <ul
                                v-for="categorie in categories.slice(
                                    Math.ceil(categories.length / 2),
                                    categories.length
                                )"
                                :key="categorie.id"
                                class="category-menu__list"
                            >
                                <li class="category-menu__list-item--title">
                                    <router-link
                                        :to="{
                                            name: 'CategoryID',
                                            params: { id: categorie.url }
                                        }"
                                    >
                                        {{ categorie.name }}
                                    </router-link>
                                </li>

                                <template v-if="categorie.children">
                                    <li
                                        v-for="subCategorie in categorie.children.slice(0, 5)"
                                        :key="subCategorie.id"
                                        class="category-menu__list-item"
                                    >
                                        <router-link
                                            :to="{
                                                name: 'CategoryID',
                                                params: {
                                                    id: subCategorie.url,
                                                }
                                            }"
                                        >
                                            {{ subCategorie.name }}
                                        </router-link>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>

                    <transition name="show-mobile-menu">
                        <div
                            v-if="isHamburgerMenu || isHamburgerSubMenu"
                            class="cabinet__mobile-menu"
                        >
                            <transition name="show-main-mobile-menu">
                                <div
                                    v-if="isHamburgerMenu"
                                    class="cabinet__hamburger-menu js-catalog-menu-mobile"
                                >
                                    <div
                                        class="cabinet__hamburger-menu-item cabinet__hamburger-menu-item--head	d-flex align-items-center	justify-content-between"
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-title"
                                        >
                                            Каталог
                                        </div>
                                        <div
                                            class="cabinet__hamburger-menu-close	js-catalog-close-mobile"
                                            @click="closeHamburgerMenu"
                                        ></div>
                                    </div>
                                    <a
                                        v-for="categorie in categories"
                                        :key="categorie.id"
                                        href="javascript:void(0)"
                                        class="cabinet__hamburger-menu-item	d-flex align-items-center	justify-content-between	js-catalog-category-mobile"
                                        @click="
                                            selectCategoryType(
                                                categorie.id
                                            )
                                        "
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-text"
                                        >
                                            {{ categorie.name }}
                                        </div>
                                        <div
                                            class="cabinet__hamburger-menu-arrow"
                                        ></div>
                                    </a>
                                    <a
                                        href="http://russianjeweller.ru"
                                        target="_blank"
                                        class="cabinet__hamburger-menu-item	d-flex align-items-center  justify-content-between	js-catalog-category-mobile"
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-text"
                                        >
                                            Русский Ювелир

                                            <p
                                                class="cabinet__hamburger-menu-text--subtitle"
                                            >
                                                Проект журнала "Русский Ювелир"
                                                <span class="no-wrap"
                                                    >(издается с 1996 г.)</span
                                                >
                                            </p>
                                        </div>
                                    </a>
                                </div>
                            </transition>

                            <transition name="show-sub-mobile-menu">
                                <div
                                    v-if="isHamburgerSubMenu"
                                    class="cabinet__hamburger-submenu	js-catalog-submenu-mobile"
                                >
                                    <div
                                        class="cabinet__hamburger-menu-item cabinet__hamburger-menu-item--head	d-flex align-items-center	justify-content-between"
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-back js-catalog-back-mobile"
                                            @click="hamburgerMenuBack"
                                        ></div>
                                        <div
                                            class="cabinet__hamburger-menu-close	js-catalog-close-mobile"
                                            @click="closeHamburgerMenu"
                                        ></div>
                                    </div>
                                    <a
                                        href="javascript:void(0)"
                                        class="cabinet__hamburger-menu-item cabinet__hamburger-menu-item--title d-flex	align-items-center justify-content-between"
                                        @click="
                                            switchingFromMobileMenu(
                                                activeCategorie
                                            )
                                        "
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-title"
                                        >
                                            {{ activeCategorie.name }}
                                        </div>
                                    </a>
                                    <a
                                        v-for="subCategorie in activeCategorie.children"
                                        :key="subCategorie.id"
                                        href="javascript:void(0)"
                                        class="cabinet__hamburger-menu-item	d-flex align-items-center	justify-content-between"
                                        @click="switchingFromMobileMenu(subCategorie)"
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-text"
                                        >
                                            {{ subCategorie.name }}
                                        </div>
                                    </a>
                                </div>
                            </transition>
                        </div>
                    </transition>

                    <ul class="cabinet-nav-list--sub-list">
                        <li
                            v-for="categorie in categories"
                            :key="categorie.id"
                            class="cabinet-nav-list__item"
                        >
                            <router-link
                                :to="
                                    `/account/catalog/category/${categorie.url}`
                                "
                                class="cabinet-nav-list__link flex flex-align-center	js-menu-link"
                            >
                                <div class="cabinet-nav-list__link-title">
                                    {{ categorie.name }}
                                </div>
                            </router-link>

                            <div v-if="categorie.children && categorie.children.length" class="cabinet-nav__category-menu category-menu">
                                <div class="category-menu__left">
                                    <ul
                                        v-for="categorie in categorie.children.slice(
                                            0,
                                            categorie.children.length > 1 ? Math.ceil(categorie.children.length / 2) : 1
                                        )"
                                        :key="categorie.id"
                                        class="category-menu__list"
                                    >
                                        <li class="category-menu__list-item--title">
                                            <router-link
                                                :to="{
                                                    name: 'CategoryID',
                                                    params: { id: categorie.url }
                                                }"
                                            >
                                                {{ categorie.name }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>

                                <div class="category-menu__right">
                                    <ul
                                        v-for="categorie in categorie.children.slice(
                                            Math.ceil(categorie.children.length / 2),
                                            categorie.children.length
                                        )"
                                        :key="categorie.id"
                                        class="category-menu__list"
                                    >
                                        <li class="category-menu__list-item--title">
                                            <router-link
                                                :to="{
                                                    name: 'CategoryID',
                                                    params: { id: categorie.url }
                                                }"
                                            >
                                                {{ categorie.name }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>

                <li class="cabinet-nav-list__item">
                    <router-link
                        to="/account/brands"
                        class="cabinet-nav-list__link flex flex-align-center js-menu-link"
                    >
                        <i class="cabinet-nav__icon cabinet-nav__icon--tag"></i>
                        <div class="cabinet-nav-list__link-title">Бренды</div>
                    </router-link>
                </li>

                <li
                    class="cabinet-nav-list__item cabinet-nav-list__item--basket"
                >
                    <router-link
                        to="/account/cart"
                        class="cabinet-nav-list__link flex flex-align-center js-menu-link"
                    >
                        <i class="cabinet-nav__icon cabinet-nav__icon--basket">
                            <span
                                v-if="cartCount > 0"
                                class="cabinet-nav-list__quantity-in-the-basket"
                                >{{ cartCount > 99 ? '99+' : cartCount }}</span
                            >
                        </i>
                        <div class="cabinet-nav-list__link-title">Корзина</div>
                    </router-link>
                </li>

                <li
                    class="cabinet-nav-list__item cabinet-nav-list__item--lists"
                >
                    <router-link
                        to="/account/lists"
                        class="cabinet-nav-list__link flex flex-align-center js-menu-link"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--star"
                        ></i>
                        <div class="cabinet-nav-list__link-title">Списки</div>
                    </router-link>
                </li>

                <li
                    class="cabinet-nav-list__item cabinet-nav-list__item--orders"
                >
                    <router-link
                        to="/account/orders"
                        class="cabinet-nav-list__link flex flex-align-center js-menu-link"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--box-open"
                        ></i>
                        <div class="cabinet-nav-list__link-title">Заказы</div>
                    </router-link>
                </li>

                <li
                    class="cabinet-nav-list__item cabinet-nav-list__item--russian-jeweler"
                >
                    <a
                        href="http://russianjeweller.ru"
                        target="_blank"
                        class="cabinet-nav-list__link flex js-menu-link"
                    >
                        <!-- <i class="cabinet-nav__icon cabinet-nav__icon--russian-jeweler"></i> -->
                        <div class="cabinet-nav-list__link-title">
                            Русский Ювелир

                            <p class="cabinet-nav-list__link-title--subtitle">
                                Проект журнала "Русский Ювелир" (издается с 1996
                                г.)
                            </p>
                        </div>
                    </a>
                </li>

                <li
                    ref="dropdownCabinetNavFooterMobile"
                    class="cabinet-nav-list__item"
                >
                    <a
                        href="javascript:void(0)"
                        class="cabinet-nav-footer__link cabinet-nav-footer__link--yet flex flex-align-center js-menu-link d-flex d-md-none"
                        @click="showDropdownCabinetNavFooter"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--ellipsis"
                        ></i>
                        <div class="cabinet-nav-footer__link-title">Ещё</div>
                    </a>

                    <div
                        v-if="isDropdownCabinetNavFooter"
                        id="nav-dropdown"
                        class="app-dropdown app-dropdown--nav js-dropdown"
                    >
                        <div class="app-dropdown__main-menu">
                            <router-link
                                to="/account/lists"
                                class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center js-menu-link"
                            >
                                <i
                                    class="cabinet-nav__icon cabinet-nav__icon--star"
                                ></i>
                                <div
                                    class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                                >
                                    Списки
                                </div>
                            </router-link>
                            <router-link
                                to="/account/orders"
                                class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center js-menu-link"
                            >
                                <i
                                    class="cabinet-nav__icon cabinet-nav__icon--box-open"
                                ></i>
                                <div
                                    class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                                >
                                    Заказы
                                </div>
                            </router-link>
                        </div>
                        <router-link
                            to="/account/settings"
                            class="app-dropdown__item"
                            >Настройки аккаунта</router-link
                        >
                        <a href="/auth/logout" class="app-dropdown__item"
                            >Выйти</a
                        >
                        <a
                            href="javascript:void(0)"
                            class="app-dropdown__item js-modal-toogle d-md-none"
                            data-target="js-modal-help"
                        >
                            Помощь
                        </a>
                    </div>
                </li>
            </ul>
        </div>

        <div
            ref="dropdownCabinetNavFooter"
            data-target="nav-dropdown"
            class="cabinet-nav-footer cabinet-nav-footer--public flex flex-justify-sb flex-align-center js-dropdown-toogle d-none d-md-flex"
            @click="showDropdownCabinetNavFooter"
        >
            <a
                href="javascript:void(0)"
                class="cabinet-nav-footer__link cabinet-nav-footer__link--user flex flex-align-center js-menu-link"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--user"></i>
                <div class="cabinet-nav-footer__link-title">
                    {{ user.LoginName }}
                </div>
            </a>
            <a
                href="javascript:void(0)"
                class="cabinet-nav-footer__link cabinet-nav-footer__link--yet flex flex-align-center js-menu-link"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--ellipsis"></i>
                <div class="cabinet-nav-footer__link-title">Ещё</div>
            </a>
            <div class="cabinet-nav-footer__arrow"></div>

            <div
                v-if="isDropdownCabinetNavFooter"
                id="nav-dropdown"
                class="app-dropdown app-dropdown--nav js-dropdown"
            >
                <div class="app-dropdown__main-menu">
                    <router-link
                        to="/account/lists"
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center js-menu-link"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--star"
                        ></i>
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Списки
                        </div>
                    </router-link>
                    <router-link
                        to="/account/orders"
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center js-menu-link"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--box-open"
                        ></i>
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Заказы
                        </div>
                    </router-link>
                </div>
                <router-link to="/account/settings" class="app-dropdown__item"
                    >Настройки аккаунта</router-link
                >
                <a href="/auth/logout" class="app-dropdown__item">Выйти</a>
                <a
                    href="javascript:void(0)"
                    class="app-dropdown__item js-modal-toogle d-md-none"
                    data-target="js-modal-help"
                >
                    Помощь
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'RetailerNav',

    data() {
        return {
            isHamburgerMenu: false,
            isHamburgerSubMenu: false,
            categorieID: 7,
            isDropdownCabinetNavFooter: false
        }
    },

    computed: {
        ...mapGetters({
            isHamburgerMenuStore: 'isHamburgerMenuStore'
        }),
        ...mapGetters('publicCategories', ['categories', 'loading']),
        ...mapGetters('cart', ['cartCount']),
        ...mapGetters('user', ['user']),
        activeCategorie() {
            return this.categories.filter(
                el => el.id === this.categorieID
            )[0]
        },
        isMobile() {
            return document.documentElement.clientWidth < 767 ? true : false
        }
    },

    watch: {
        isHamburgerMenuStore(value) {
            value === true ? this.showMenu() : null
        }
    },

    created() {
        this.getCategories()
    },

    mounted() {
        document.addEventListener('click', this.closeDropdownCabinetNavFooter)
    },

    beforeDestroy() {
        document.removeEventListener(
            'click',
            this.closeDropdownCabinetNavFooter
        )
    },

    methods: {
        ...mapActions('publicCategories', ['getCategories']),
        ...mapActions(['closeHamburgerMenuStore']),
        selectCategoryType(categorieID) {
            this.categorieID = categorieID
            this.isHamburgerMenu = false
            this.isHamburgerSubMenu = true
        },
        showMenu() {
            this.isHamburgerMenu = !this.isHamburgerMenu

            document.documentElement.classList.toggle('no-scroll')
        },
        closeHamburgerMenu() {
            this.isHamburgerMenu = false
            this.isHamburgerSubMenu = false

            document.documentElement.classList.toggle('no-scroll')

            this.closeHamburgerMenuStore()
        },
        hamburgerMenuBack() {
            this.isHamburgerSubMenu = false
            this.isHamburgerMenu = true
        },
        showDropdownCabinetNavFooter() {
            this.isDropdownCabinetNavFooter = !this.isDropdownCabinetNavFooter
        },
        closeDropdownCabinetNavFooter(e) {
            if (window.innerWidth > 1000) {
                if (
                    !this.$refs.dropdownCabinetNavFooter.contains(e.target) ||
                    !this.$el.contains(e.target)
                ) {
                    this.isDropdownCabinetNavFooter = false
                }
            } else {
                if (
                    !this.$refs.dropdownCabinetNavFooterMobile.contains(
                        e.target
                    ) ||
                    !this.$el.contains(e.target)
                ) {
                    this.isDropdownCabinetNavFooter = false
                }
            }
        },
        switchingFromMobileMenu(value) {
            this.$router.push({
                name: 'CategoryID',
                params: { id: value.url }
            })

            this.closeHamburgerMenu()
        },
    }
}
</script>
